// File: src/components/Page.jsx
import React from "react";
import { useParams } from 'react-router-dom';

export default function Page() {
    const { page } = useParams();
    return (
        <div className="text-center py-20 text-white">
            <h2 className="text-4xl font-bold capitalize">{page.replace(/-/g, ' ')}</h2>
            <p className="mt-4 text-gray-400">This is a placeholder page for {page.replace(/-/g, ' ')}.</p>
        </div>
    );
}